var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a Tray Tab Top Button
 *
 * @class
 */

class TrayTabButton extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'title': 'no title',
                'description': '',
                'icon': false
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__tray__tabs__top__button float'>
                <a class='btn btn--m btn--accent_none_accent js-editor__tray__tabs__top__button' title='<%- title %>'>
                    <% if(icon){ %><div class='btn__icon'><%= embedded_svg(icon) %></div><% } %>
                    <div class='btn__txt'><%- title %></div>
                </a>
            </div>
        `;

        super.render();

        /**
         * Click event
         *
         * @fires TrayTabButton#_clicked
         */

         $('.js-editor__tray__tabs__top__button', this.$el).on('click', this._clicked);
    }

    /**
     * @event TrayTabButton#Cioui:TrayTabButton:clicked
     * @property {String}Cioui:TrayTabButton:clicked
     * @returns {Object} event - native click Event
     */

    _clicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:TrayTabButton:clicked', e);
    }

}
module.exports = TrayTabButton;